import { createAsyncAction } from 'typesafe-actions'

export const uploadFileAsyncReq = createAsyncAction(
  'uploadfile/UPLOAD_FILE_REQUEST',
  'uploadfile/activity/UPLOAD_FILE_RESPONSE',
  'uploadfile/activity/UPLOAD_FILE_FAILURE'
)<any, any, any>()
